import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Image from "aldoo-ra/Image"

const HeaderSectionRight = () => {
  return (
    <div 
      className="flex w-full lg:w-1/2 max-w-[500px] md:max-w-[628px] lg:max-w-auto md:h-[450px] lg:h-[412px] xl:h-[516px] aspect-1312/1156 items-center justify-center lg:justify-end"
      style={{zIndex: 10}}
    >
      {/* Image Section */}
      <Image
        id="HomeHeaderImage"
        className="w-full h-full object-contain"
      />
    </div>
  );
};

export default HeaderSectionRight;
